import { generateUtilityClass, generateUtilityClasses } from '@mui/base';
export function getInputLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiInputLabel', slot);
}
const inputLabelClasses = generateUtilityClasses('MuiInputLabel', ['root', 'focused', 'disabled', 'error', 'required', 'asterisk', 'formControl', 'sizeSmall', 'shrink', 'animated', 'standard', 'filled', 'outlined']);
export default inputLabelClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/InputLabel/inputLabelClasses.js
// module id = 320
// module chunks = 1